(() => {
  var e = {};
  window.PXUTheme.jsCollectionSlider = {
    init: function(e) {
      window.PXUTheme.jsCollectionSlider = $.extend(this, window.PXUTheme.getSectionData(e)), this.enable_masonry_layout && !this.align_height && "grid" == this.collection_style && window.PXUTheme.applyMasonry(), "slider" == this.collection_style && this.createSlider()
    },
    createSlider: function() {
      let e = $(".collection-slider.layout--slider .slider-gallery");
      const l = {
        collections_per_slide: this.collections_per,
        collections_available: this.collections_available,
        collections_limit: this.collections_limit,
        cellAlign: "left",
        wrapAround: !0,
        autoPlay: this.autoPlay,
        pauseAutoPlayOnHover: this.pauseAutoPlayOnHover
      };
      $(e).flickity({
        lazyLoad: 2,
        watchCSS: true,
        freeScroll: !0,
        imagesLoaded: !0,
        draggable: !0,
        cellAlign: "center",
        wrapAround: l.wrapAround,
        pageDots: !0,
        contain: !0,
        prevNextButtons: !1,
        initialIndex: 0,
        autoPlay: l.autoPlay,
        pauseAutoPlayOnHover: l.pauseAutoPlayOnHover
      })
    },
    unload: function(e) {
      let l;
      e.find(".flickity-enabled").flickity("destroy")
    }
  }
})();
//# sourceMappingURL=/s/files/1/0415/2445/t/190/assets/z__jsCollectionSlider.js.map?v=1630405070